import { useEffect } from 'react'
import useResponsiveDesign from './useResponsiveDesign'
import { sendMessageToNativeApp } from 'utils/sendMessageToNativeApp'

export const useFinishedRenderingNativeMessage = () => {
  const { isIOSNative } = useResponsiveDesign()
  useEffect(() => {
    if (!isIOSNative) return

    sendMessageToNativeApp('finishedRendering')
  }, [isIOSNative])
}
